module.exports = __webpack_public_path__ + "static/champions_fight-90e9e50e7a73584de1695fec3f0f0ddb.jpg";